// extracted by mini-css-extract-plugin
export default {"dialog":"JsonSchemaDialog-module__dialog--IF3wE"};